// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"navigationitem__Navigation__3Ofx3","active":"navigationitem__active__35UmS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navigationitems/Navigationitem/navigationitem.css
// module id = 80
// module chunks = 3